import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
const tournaments = [
  {
    id: 1,
    name: "Fire Fighter",
    game: "Fighter",
    prize: "₦5,000",
    image: "./assets/gamescard/firefighter.png",
  },
  {
    id: 2,
    name: "Battle Arena",
    game: "Battle",
    prize: "₦7,500",
    image: "./assets/gamescard/battlearena.png",
  },
  {
    id: 3,
    name: "Gameio Road Mash",
    game: "Gameio Road",
    prize: "₦10,000",
    image: "./assets/gamescard/roadmash.png",
  },
];

const Tournament = () => {
  const [position, setPosition] = useState({ x: 50, y: 50 });

  // Mouse light follow effect
  useEffect(() => {
    const handleMouseMove = (e) => {
      const x = (e.clientX / window.innerWidth) * 100;
      const y = (e.clientY / window.innerHeight) * 100;
      setPosition({ x, y });
    };

    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  return (
    <div className="relative bg-[#0b0b18] text-white min-h-screen overflow-hidden">

      {/* ðŸ”¥ Animated Grid Background */}
      <div className="absolute inset-0 animated-grid"></div>

      {/* ðŸŒŒ Moving Gradient Glow */}
      <div className="absolute inset-0 gradient-overlay"></div>

      {/* ðŸŽ¯ Mouse Follow Light */}
      <div
        className="pointer-light"
        style={{
          left: `${position.x}%`,
          top: `${position.y}%`,
        }}
      ></div>

      {/* Content */}
      <section className="relative z-10 text-center py-32 px-6">
        <h1 className="text-6xl md:text-7xl font-extrabold bg-gradient-to-r from-purple-400 via-pink-500 to-purple-500 bg-clip-text text-transparent animate-gradient">
          Gameio Tournaments
        </h1>

        <p className="mt-6 text-gray-300 max-w-2xl mx-auto">
          Join high-stakes competitive gaming events and win massive rewards.
        </p>

            <Link 
  to="/Gameiosign"
  className="mt-8 inline-block px-10 py-3 rounded-full font-semibold 
             bg-gradient-to-r from-purple-600 to-pink-600 
             hover:scale-105 transition duration-300 text-white"
>
  Join Now
</Link>
      </section>

      {/* Cards */}
      <section className="relative z-10 max-w-7xl mx-auto px-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-10 pb-32">
        {tournaments.map((tournament) => (
          <div
            key={tournament.id}
            className="bg-[#141427] rounded-2xl overflow-hidden border border-white/10 hover:border-pink-500 transition duration-500 hover:-translate-y-2"
          >
            <img
              src={tournament.image}
              alt={tournament.name}
              className="h-64 w-full object-cover"
            />

            <div className="p-6">
              <h3 className="text-2xl font-bold mb-2">
                {tournament.name}
              </h3>

              <p className="text-gray-400 text-sm">
                Game: {tournament.game}
              </p>

              <p className="text-pink-500 font-semibold mt-2">
                Prize: {tournament.prize}
              </p>

                   <Link 
  to="/Gameiosign"
  className="mt-8 inline-block px-10 py-3 rounded-full font-semibold 
             bg-gradient-to-r from-purple-600 to-pink-600 
             hover:scale-105 transition duration-300 text-white"
>
  Join Now
</Link>
            </div>
          </div>
        ))}
      </section>

      {/* Custom CSS */}
      <style>{`

        /* Gradient animated text */
        @keyframes gradientMove {
          0% { background-position: 0% }
          100% { background-position: 200% }
        }
        .animate-gradient {
          background-size: 200% auto;
          animation: gradientMove 4s linear infinite;
        }

        /* Grid Animation */
        .animated-grid {
          background-image: linear-gradient(rgba(255,255,255,0.04) 1px, transparent 1px),
                            linear-gradient(90deg, rgba(255,255,255,0.04) 1px, transparent 1px);
          background-size: 50px 50px;
          animation: moveGrid 25s linear infinite;
        }

        @keyframes moveGrid {
          from { background-position: 0 0; }
          to { background-position: 50px 50px; }
        }

        /* Moving Gradient Overlay */
        .gradient-overlay {
          background: radial-gradient(circle at center, rgba(168,85,247,0.15), transparent 60%);
          animation: pulseGlow 6s ease-in-out infinite alternate;
        }

        @keyframes pulseGlow {
          0% { opacity: 0.4; }
          100% { opacity: 0.8; }
        }

        /* Mouse Follow Light */
        .pointer-light {
          position: absolute;
          width: 400px;
          height: 400px;
          background: radial-gradient(circle, rgba(236,72,153,0.25), transparent 70%);
          transform: translate(-50%, -50%);
          pointer-events: none;
          transition: 0.1s ease;
        }

      `}</style>
    </div>
  );
};

export default Tournament;